import { t } from '@lingui/core/macro'

export const realmLabelsStrategy: { [key: string]: Map<string, string> } = {
  PortalNissan: new Map([
    ['grupo.dealer', t`Grupos Econômicos`],
    ['somente.brasileiros', t`Usuários estrangeiros não são permitidos`]
  ]),

  default: new Map<string, string>()
}
